import React from "react";

export const Settings: React.FC = () => {

    return (
        <div className="bfs-settings">
            Settings
        </div>
    )
}